export default __webpack_public_path__ + "static/overpass-regular-fb35cdbe0337078a121ef85012043ed1.woff2";